export const USER_LOGIN = 'USER_LOGIN';
export const USER_UPDATE_INFO = 'USER_UPDATE_INFO';
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_CLEAR_SESSION = 'USER_CLEAR_SESSION';
